import { render, staticRenderFns } from "./contactUsPhone.vue?vue&type=template&id=0cf61360&scoped=true"
import script from "./contactUsPhone.vue?vue&type=script&lang=js"
export * from "./contactUsPhone.vue?vue&type=script&lang=js"
import style0 from "./contactUsPhone.vue?vue&type=style&index=0&id=0cf61360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf61360",
  null
  
)

export default component.exports